import Pagination from './../../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import Loader from '../../../../../shared/components/loader';
import DatePicker from 'vue2-datepicker';
import CONSTANT from './../../../../../shared/constants/constant';
import BookingService from './../../../../services/cargobooking.service';
import createcargosellerdetails from './../createcargosellerdetails';
import MasterService from './../../../../../masterdata/services/masterdata.service';
import Util from './../../../../../shared/util/util';
import moment from 'moment';
export default {
  name: 'cargosellerdetailslisting',
  components: {
    Pagination,
    MasterService,
    DatePicker,
    moment,
    Loader,
    createcargosellerdetails,
    CustomExpandableTable
  },
  data: function() {
    return {
      sellerno:"",
      fromdate:'',
      todate:'',
      type:"CARGO_SELLER_DETAILS",
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      isLoading:false,
      showCreateSellerdetails:false,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: ['Seller ID','Seller Name', 'Seller GST No', 'Seller Address','Pincode','Hub','Created By','Created Date','Status','Action'],
      innerTableColumn: [''],
      tableItems: [],
      selectedSellerDetailsObj: "",
      ToDateErr:"",
      FromDateErr:"",
    }
  },
  computed: {

  },
  mounted() {
  this.getCargoSellerListing();
  },
  methods: {
    showsellerDetails(){
    this.showCreateSellerdetails = true;
    this.selectedSellerDetailsObj = [];
    },
    searchSellerDetails(){
      this.currentPage = 1;
      this.offset = 0;
      this.getCargoSellerListing();
    },
    async getCargoSellerListing(){
      try {
        if(this.checkErr() == 1){
          return false
        }
        this.isLoading = true;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit
        }
        if(this.sellerno!=""){
          inputPayload.sellerno = this.sellerno;
        }
        if(this.fromdate!=null && this.fromdate!=""){
           inputPayload.fromdate = moment(this.fromdate).format('MM-DD-YYYY');
        }
        if(this.todate!=null && this.todate!=""){
          inputPayload.todate = moment(this.todate).format('MM-DD-YYYY');

        }

        let result = await BookingService.getCargoSellerDetails(inputPayload)
        this.tableArr = result.data.data.rows;
        this.totalCount = result.data.data.count;
        if(this.totalCount>0){
          this.tableItems = result.data.data.rows.map((el)=>{
            console.log("el",el)
            return {
              'id':el.id,
              'Seller ID':el.sellerid,
              'Seller Name': el.sellername,
              'Seller GST No': el.gstin,
              'Seller Address': el.address,
              'Pincode': el.pincode,
              'Hub': el.hub,
              'Created By': el.createdby,
              'Created Date':Util.displayDateOnlyFormat(el.createddate),
              'Status': el.status,
              'Action': "action"
            }                                                                                                     
          })
        }else{
          this.tableItems = [];                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
        }
                                            
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    checkErr() {
      let err = 0
      if ((this.fromdate != null && this.fromdate != "") && (this.todate != null && this.todate != "")) {
        this.FromDateErr = ""
        this.ToDateErr = ""
        err = 0
      }
      else {
        if (this.fromdate != null && this.fromdate != "") {
          this.ToDateErr = "Please Select To Date"
          this.FromDateErr = ""
          err = 1
        }
        else if (this.todate != null && this.todate != "") {
          this.FromDateErr = "Please Select From Date"
          this.ToDateErr = ""
          err = 1
        }
        else {
          this.FromDateErr = ""
          this.ToDateErr = ""
        }
      }
      return err
    },
    clearForm(){
      this.currentPage = 1;
      this.offset = 0;
      this.sellerno = "";
      this.fromdate = "";
      this.todate = "";
      this.getCargoSellerListing();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getCargoSellerListing();
    },
    async getCustomTableEvent(event){
      if(event.actionType=="active"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       });
     }else if(event.actionType=="inactive"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       })
      }
      if(event.actionType=="edit"){
        let selectedSellerObj  = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedSellerDetailsObj = selectedSellerObj;
        this.showCreateSellerdetails = true;
      }
    },
    callParent() {
      this.showCreateSellerdetails = false;
      this.currentPage = 1;
      this.offset = 0;
      this.getCargoSellerListing();
    },
    async activeAction(data){
      try {
        this.isLoading = true;
        var item = this.tableArr.find(item => item.id === data.id);
        var isactivestatus = item.status == 0 ? 1 : 0
        let inputPayload = {
          "id": data.id,
          "type": this.type,
          "status": isactivestatus
        }
        let result = await MasterService.changeStatus(inputPayload)
        if(result.data.code == 200){
          if(result.data.data[0].status == 0){
          this.$alert("Cargo Seller Details Activated Successfully!!",this.sellerno, "success");
        }else{
          this.$alert("Cargo Seller Details Inactivated Successfully!!",this.sellerno, "success");
         }
          this.getCargoSellerListing();
          this.isLoading = false;
        }
      } catch(err){
        console.log(err);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/cargosellerdetails/cargosellerdetailsListing/cargosellerdetailsListing.component.js